import React from "react";
import { Form, Input, Modal, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import { PASSWORD_RULES } from "../../common/constants";
import { useUpdateMyPasswordMutation } from "../../graphql/generated/hooks";

const ChangePasswordModal: React.FC<{ isOpen: boolean; close: Function }> = ({
  isOpen,
  close,
}) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [changePassword, { loading }] = useUpdateMyPasswordMutation();

  const onFinish = async (values: any) => {
    await changePassword({
      variables: {
        oldPassword: values.password,
        newPassword: values.new_password,
      },
    })
      .then(() => {
        messageApi.success(t("message.success.data_updated"));
        close();
      })
      .catch((error) => {
        messageApi.error(t("message.error.data_update_failed"));
        console.error(error);
      });
  };

  return (
    <Modal
      title={t("title.change_password")}
      open={isOpen}
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        close();
        form.resetFields();
      }}
      confirmLoading={loading}
    >
      {contextHolder}
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{ marginTop: "20px" }}
      >
        <Form.Item
          rules={[
            { required: true, message: t("message.error.field_required") },
          ]}
          name="password"
          label={t("label.enter_old_password")}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true, message: t("message.error.field_required") },
            ...PASSWORD_RULES.map((rec) => ({
              ...rec,
              message: t(rec.message),
            })),
          ]}
          hasFeedback
          name="new_password"
          label={t("label.enter_new_password")}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="new_password_confirmation"
          label={t("label.enter_new_password_confirmation")}
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: t("message.error.field_required") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
